<template>
  <div v-if="showPage403" class="animated fadeIn content-holder"> 
    <Page403></Page403>
  </div>
  <div v-else class="animated fadeIn content-holder">
    <b-card no-body>
      <b-card-header v-if="permission.capabilities.Create || permission.capabilities.Edit" class="custom-header">
        <div><i class="icon-settings"></i> General settings</div>
        <b-button-group> 
          <router-link to="/">
            <b-button class="custom-cancel"><i class="fa fa-times text-danger"></i>
                &nbsp;Cancel
            </b-button>
          </router-link>
          <b-button v-on:click="post('andClose')" :disabled="$v.form.$invalid || submitted">
            <i class="fa fa-save"></i>&nbsp;Save & Close  
          </b-button>

          <b-button v-on:click="post()" :disabled="$v.form.$invalid">
            <i class="fa fa-check text-success "></i>&nbsp;Apply
            </b-button> 
        </b-button-group>

      </b-card-header>

      <!-- Modal Component -->
      <div>
        <Modals ref="form"></Modals>
      </div>

      <b-card-body v-if="isLoading">
        <spinner></spinner> 
      </b-card-body>
      <b-card-body v-else>
        <b-row v-if="permission.capabilities.Create || permission.capabilities.Edit">
          <b-col md="12">
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
              <b-row>
                <b-col md="4">
                  <b-form-group id="settingKey"
                    label="Key"
                    label-for="settingKey">
                    <b-form-input id="settingKey"
                      type="text"
                      v-model.lazy.trim="$v.form.settingKey.$model"
                      :state="chkState('settingKey')"
                      aria-describedby="settingKey"
                      placeholder="Key"
                      autocomplete='Key'/>
                    <b-form-invalid-feedback id="settingKey">
                      This is a required field and must be at least 5 character
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col md="8">
                  <b-form-group id="settingValue"
                    label="Value"
                    label-for="settingValue">
                    <b-form-input id="settingValue"
                      type="text"
                      v-model.lazy.trim="$v.form.settingValue.$model"
                      :state="chkState('settingValue')"
                      aria-describedby="settingValue"
                      placeholder="Value"
                      autocomplete="Value" />
                    <b-form-invalid-feedback id="settingValue">
                      This is a required field and must be at least 5 character
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback  v-if="settings_key === '01c300fd-7540-4058-b871-6cb1d18f55bd'" id="settingValueLiveFeedbackForDefaultDomain" style="display:block">
                      Changing this value will require to configure again in AWS Cloudfront and Route53 services
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <br/>
          </b-col>
        </b-row>
        
        <v-client-table v-if="permission.capabilities.View" :columns="columns" :data="data" :options="options" :theme="theme" id="settingTable"> 
          <div slot="action" slot-scope="props" >
              <div class="input-group input-group-sm action">                             
                <b-dropdown variant="link" size="sm" no-caret>
                  <template v-slot:button-content>
                    <i class="fa fa-cog" aria-hidden="true"></i>
                  </template>
                  <b-dropdown-item @click="openEditPage(props.row.settings_key)" :disabled="!permission.capabilities.Edit"><i class="fa fa-edit"></i>&nbsp;Edit</b-dropdown-item>
                  <b-dropdown-item 
                    @click="openDeleteModal(props.row.settings_key, props.row.settingKey)" :disabled="!permission.capabilities.Delete"
                    v-if="props.row.settings_key != '01c300fd-7540-4058-b871-6cb1d18f55bd'"
                  >
                    <span style="color: #20a8d8;">
                      <i class="fa fa-trash"></i>&nbsp;Delete
                    </span>
                  </b-dropdown-item>
               </b-dropdown>
              </div>
          </div>
        </v-client-table>
      </b-card-body>
    </b-card>
    <DeleteConfirmModal 
      v-bind:modalTitle="deleteModal.modalTitle"
      v-bind:modalMsg="deleteModal.modalMsg"
      v-bind:loginUserRoleName="deleteModal.loginUserRoleName"
      v-on:toggle="getDeleteAction($event)" 
      ref="deleteConfirmModal"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import {ClientTable, Event} from 'vue-tables-2';
import miniToastr from 'mini-toastr';
import VueNotifications from 'vue-notifications';
import { validationMixin } from "vuelidate";
import { required, minLength, helpers } from "vuelidate/lib/validators";
import { router } from '../../router/index';
import { apigClient } from '@/shared/api';
import { timezones } from '@/shared/helper';
import Modals from "@/shared/Modals.vue";
import DeleteConfirmModal from "./../custom-components/DeleteConfirmModal";
import Page403 from "@/views/pages/Page403.vue";
const Spinner = () => import('../shared/Spinner');

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options);
Vue.use(ClientTable);

//Column's customization depending on the user's role
let columns = ['action', 'settingKey',  'settingValue'];

let headings = {
  action: '',
  settingKey: 'Key',
  settingValue: 'Value'
}
let sortable = ['settingKey',  'settingValue'];

const formShape = {
  settingKey: "",
  settingValue: ""
}

let validations = {
  form: {
    settingKey:{
      required,
      minLength: minLength(5)
    },
    settingValue:{
      required,
      minLength: minLength(5)
    },
  }
}

export default {
  name: "GeneralSettings",
  components: {
    ClientTable,
    Spinner,
    Modals,
    DeleteConfirmModal,
    Page403
  },
  data() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    return {
      loginUserInfo: loginUserInfo,
      permission: {
        permissionBaseName: null,
        permissionBaseNameCapabilities: null,
        capabilities: {
          View: false,
          Edit: false,
          Delete: false,
          Create: false,
        }
      },
      showPage403: false,
      form: Object.assign({}, formShape),
      feedBack: 'secondary',
      submitted: false,
      disabled: true,
      isLoading: true,
      settings_key: '',
      columns: columns, 
      keyName: '',
      data: [],
      options: {
        headings: headings,
        sortable: sortable,
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: false,
          nav: 'scroll'
        }
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      deleteModal:{
        modalTitle: 'Delete a Key',
        modalMsg: '',
        loginUserRoleName: loginUserInfo.db.roleName,
        deleteAction: '',
      },
    }
  },
  mounted: function(){
    let that = this;
    that.getPermission();
    if(!that.permission.capabilities.View && !that.permission.capabilities.Create 
        && !that.permission.capabilities.Edit && !that.permission.capabilities.Delete){
      that.showPage403 = true;
      return;
    }

    if(that.permission.capabilities.View){
      that.getSettingsData();
    }
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: validations,
  methods: {
    getPermission(){
      let that = this;
      const userPermissionsBasedOnEntity = that.loginUserInfo.db.userPermissionsBasedOnEntity;
      if(this.$route.meta && userPermissionsBasedOnEntity){
        that.permission.permissionBaseName = this.$route.meta.permissionBaseName;
        let userPermissionBasedOnEntity = userPermissionsBasedOnEntity.find(p => p.permissionBaseName === this.$route.meta.permissionBaseName);
        if(userPermissionBasedOnEntity){
          that.permission.permissionBaseNameCapabilities = userPermissionBasedOnEntity.capabilities;
          that.permission.permissionBaseNameCapabilities.forEach(capability=>{
            that.permission.capabilities[capability.label] = capability.value
          });
        }
      } else{
        router.push('/no-permission-given');
      }
      console.log('permission: ' , that.permission);
    },
    openDeleteModal : function(id, name) {
      let that = this;
      that.deleteModal.deleteAction='';
      that.settings_key = id;
      that.keyName = name;
      that.deleteModal.modalMsg="Delete the Key '" + that.keyName  + "' ?";
      that.$refs.deleteConfirmModal.openModal();
    },
    openEditPage: function(id) {
      window.scrollTo(0, 0);
      this.settings_key = id;
      this.data.map(setting => {
        if (setting.settings_key === this.settings_key) {
          this.form.settingKey = setting.settingKey;
          this.form.settingValue = setting.settingValue;
        }
      });
    },
    getDeleteAction(data){
      let that = this;
      console.log(data);
      if(data && data.deleteAction){
        that.deleteModal.deleteAction=data.deleteAction;
        that.deleteKey();
      }
    },
    deleteKey: function() {
      let that = this;
      that.$refs.form.openModal();
      that.changeModalContent(
        "loading",
        "Processing...",
        (that.deleteModal.deleteAction=='MARK-AS-DELETED') ? "Deleting the Key ("+ that.keyName +")" :
        "Deleting the Key ("+ that.keyName +") permenently"
      );
      if(that.deleteModal.deleteAction=='MARK-AS-DELETED'){
        that.markKeyAsDeleted(that);
      } else {
        let method = 'DELETE';
        let pathTemplate = '/settings/' + that.settings_key;
        let additionalParams ={};
        let pathParams = {};

        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){          
          if(result.data.status){
            console.log('delete setting keyId: ' + that.settings_key);
            that.changeModalContent(
              "success",
              "Deleted success!",
              "The Setting Key has been deleted"
            );
            setTimeout(that.$refs.form.closeModal(), 1500);
            that.showSuccessDeleteMsg();
            that.getSettingsData();
            that.settings_key = '';
          } else{
            console.log('Error From API Endpoint: ' + result.data.message);
            that.changeModalContent(
              "error",
              "Error Occured!",
              "Error From API Endpoint: " + result.data.message
            );
          }
        }).catch( function(error){
          console.log("Error From API Endpoint: " + error.message);
          that.changeModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + error.message
          );
        });
      }
    },
    markKeyAsDeleted: (that) => {
      let method = 'PUT';
      let pathTemplate =  '/settings/'+that.settings_key+'/mark-as-deleted';
      let additionalParams ={};
      let pathParams = {};
      let body ={
        updateBy:that.loginUserInfo.login_username
      }
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams,body)
      .then(function(result){
        if(result.data.status){
          console.log(result);
          that.changeModalContent(
            "success",
            "Deleted success!",
            "The Setting Key data has been deleted"
          );
          setTimeout(that.$refs.form.closeModal(), 1500);
          that.showSuccessDeleteMsg();
          that.getSettingsData();
          that.settings_key = '';
        }else{
          console.log('Error From API Endpoint: ' + result.data.message);
          that.changeModalContent(
            "error",
            "Error Occured!",
            "Error From API Endpoint: " + result.data.message
          );
        }
      }).catch( function(error){
        that.changeModalContent(
          "error",
          "Error Occured!",
          "Error From API Endpoint: " + error.message
        );
      });
    },
    post:function(option){
      let that = this;
      let body = {}, method = '', pathTemplate = '';
      // Modal
      that.$refs.form.openModal();
      if (that.settings_key) {
        that.changeModalContent(
          "loading",
          "Updating...",
          "Updating General setting Info"
        );
        method = 'PUT';
        pathTemplate = '/settings/' + that.settings_key;
        body = {
          settingKey: that.form.settingKey,   
          settingValue: that.form.settingValue,   
          updateBy: that.loginUserInfo.login_username
        };
      } else {
        that.changeModalContent(
          "loading",
          "Saving...",
          "Saving General setting Info"
        );
        method = 'POST';
        pathTemplate = '/settings';
        body = {
          settingKey: that.form.settingKey,   
          settingValue: that.form.settingValue,   
          createBy: that.loginUserInfo.login_username
        };
      }
      let pathParams = {
      };
      let additionalParams ={
      };
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(result){
          console.log('create settings, success ' + JSON.stringify(result));
          // that.showSuccessMsgUpdate();
          if (that.settings_key) {
            that.changeModalContent(
              "success",
              "Updated success!",
              "The General setting data has been updated"
            );
          } else {
            that.changeModalContent(
              "success",
              "Saved success!",
              "The General setting data has been saved"
            );
          }
          setTimeout(() => {
            that.$refs.form.closeModal();
          }, 2000);
          that.getSettingsData();
          that.form.settingValue = '';
          that.form.settingKey = '';
          that.settings_key = '';
        }).catch( function(result){
          // that.showErrorMsg();
          that.changeModalContent(
            "error",
            "Error Occured!",
            " " + result.message
          );
        });
    },
    onSubmit() {
      if (this.validate()) {
        this.$nextTick(() => {
          // submit
          // console.log('submit:', this.formStr)
          this.submitted = true
          this.feedBack = 'info'
        })
      }
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
        this.feedBack = 'secondary'
      })
    },
    changeModalContent(status = null, title = null, message = null) {
      let that = this;
      that.$refs.form.status = status ? status : that.$refs.form.status;
      that.$refs.form.title = title ? title : that.$refs.form.title;
      that.$refs.form.message = message ? message : that.$refs.form.message;
    },
    chkState(val) {
      const field = this.$v.form[val];
      return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
    },

    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    getTimeZonesList: function() {
      this.timeZonesList = tzList;
    }, 
    getSettingsData: function() {
      this.isLoading = true;
      var that = this;
      var method = 'GET';
      var pathTemplate = '/settings';
      var additionalParams = {
        queryParams: {
          params: JSON.stringify({
            fields: ["settings_key", "settingKey", "settingValue"],
            filter: [
              {
                fieldname: "isDeleted",
                comparisonOperator: "=",
                value: false
              }
            ]
          })
        }
      };
      var pathParams = {};
      var settingsData = [];
      apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          if (result.data.status) {
            let data = result.data.data.map((elem, index) => { 
                elem.settings_key = elem.settings_key;
                elem.settingKey = elem.settingKey;
                elem.settingValue = elem.settingValue;
                return elem;
            });    
            that.data = [...data];
          } else {
            console.log(`Error found from AWS: ${result.data.message}`);
            that.showErrorMsg();
          } 
          that.isLoading = false;
        }).catch( function(error){
          console.log('ERROR ! Cannot get data:' + error);
          that.isLoading = false;
          //This is where you would put an error callback
        });
    },
  },
  notifications: {
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The settings have been updated'
    },
    showSuccessDeleteMsg: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The setting key has been deleted'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'ERROR',
      message: 'The settings cannot be saved'
    }
  },
}
</script>

<style lang="scss">
  #settingTable {
    width: 75%;
    padding: 0px;
    margin: 0px;

    .action{
      display: flex;
      justify-content: center;
      align-items: center;
    } 
  }
</style>

<style scoped>

  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }

  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }

    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 

  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }

</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }

  
</style>